module.exports = __webpack_public_path__ + "img/bikes.c7612d9d.jpg";